
import Vue from 'vue';
export default Vue.extend({
  props: {
    ariaLabel: {
      type: String,
      default: undefined,
    },
    fontWeightBold: {
      type: Boolean,
      default: true,
    },
    tertiary: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Link with some label',
    },
    url: {
      type: String,
      default: undefined,
    },
    target: {
      type: String,
      default: undefined,
    },
    icon: {
      type: [String, Boolean],
      required: false,
      default: 'arrow-right',
    },
    iconPosition: {
      type: String,
      required: false,
      default: 'trailing',
    },
    underline: {
      type: Boolean,
      default: false,
    },
    isBreadcrumb: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    type(): string | undefined {
      if (!this.url) return 'button';
      if (this.leaveMarket) return 'a';
      return this.url && !this.url.includes('://') && !this.url.includes('mailto:') && !this.url.includes('tel:')
        ? 'nuxt-link'
        : 'a';
    },
    href(): string | undefined {
      return this.type === 'a' || this.leaveMarket ? this.url : undefined;
    },
    to(): string | null {
      if (this.isBreadcrumb && this.$store.state.internalRouting) {
        return this.$store.state.internalRouting;
      }
      if (this.type !== 'a') {
        return this.url === '//' ? '/' : this.url;
      }
      return null;
    },
    getLabel(): any {
      return this.$slots.default || this.label;
    },
    leaveMarket(): boolean {
      const routeLocale = this.$route.path.split('/')[1];
      const linkLocale = this.url.split('/')[1];

      if (linkLocale !== routeLocale) return true;
      return false;
    },
  },
  data() {
    return {};
  },
  methods: {
    validateLink(): any {
      if (document.body.classList.contains('body-locked') && !this.url.includes('?showLayer')) {
        document.body.classList.remove('body-locked');
      }
      if (this.to === (this.$route.path.slice(-1) === '/' ? this.$route.path : this.$route.path + '/')) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
  },
});
